import * as React from 'react';

export const MinusIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M14 9H2V7H14V9Z" fill="currentColor" />
  </svg>
);
